import { container } from "@/arch/@core/main/ioc/ContainerRegister";
import { CreateOrGetQuizUsecase } from "@/arch/new_proposal/quizz/application/usecases/CreateOrGetQuizUsecase";
import { TYPES } from "@/arch/@core/main";
import { SendQuizAnswersUsecase } from "@/arch/new_proposal/quizz/application/usecases/SendQuizAnswersUsecase";

export const quizInstances = {
  createOrGetQuizUsecase: container.get<CreateOrGetQuizUsecase>(TYPES.CreateOrGetQuizUsecase),
  sendQuizAnswersUsecase: container.get<SendQuizAnswersUsecase>(TYPES.SendQuizAnswersUsecase),
};
